export default __webpack_public_path__ + "static/media/e-book-thumbnails.1bdb4e5d.jpg";